import React from 'react';
import PropTypes from 'prop-types';

import { SearchIcon16 } from '../RacingThemeSearch/RacingThemeSearchIcons';
import styles from './RacingThemeSearchBannerInput.module.css';

/**
 * Search banner keyword input.
 */
const RacingThemeSearchBannerInput = props => {
  const {
    value = '',
    placeholder,
    readOnly = false,
    onChange,
    onKeyDown,
  } = props;

  return (
    <div className={styles.inputWrap}>
      <SearchIcon16 />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        aria-label="Search"
        readOnly={readOnly}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

RacingThemeSearchBannerInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default RacingThemeSearchBannerInput;
